<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onOrdersSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by id"
          name="search"
        />
      </app-cells>
      <app-cells><h2 class="title">Requested</h2></app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-cash-detail', params: {id: row.id }}" class="table-default__link-border">
              Cash request - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #amount="{ row }">
          {{ row.amount.toLocaleString() }} TSh
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
      <app-cells><h2 class="title">In process</h2></app-cells>
      <v-client-table
        :data="table_process.items"
        :columns="table_process.columns"
        :options="table_process.options"
        class="table-default"
        :class="{ 'table-default--loading': table_process_preloader }"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-cash-detail', params: {id: row.id }}" class="table-default__link-border">
              Cash request - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #amount="{ row }">
          {{ row.amount.toLocaleString() }} TSh
        </template>
        <template #real_amount="{ row }">
          {{ row.real_amount.toLocaleString() }} TSh
        </template>
        <template #efd_missing="{ row }">
          {{ row.efd_missing.toLocaleString() }} TSh
        </template>
        <template #difference="{ row }">
          {{ row.difference.toLocaleString() }} TSh
        </template>
        <template #completed_orders="{ row }">
          <span
            v-tooltip="{ content: clientTableList(row.orders), placement: 'top-start', offset: 10, html: true }"
            class="status-tag"
            :style="{ 'backgroundColor': row.completed_orders === row.total_orders ? '#77b017' : '#439ad1' }"
          >
            {{ row.completed_orders }} out of {{ row.total_orders }}
          </span>
        </template>
        <template #taken_by="{ row }">
          <template v-if="row.taken_by.first_name">{{ row.taken_by.first_name }} {{ row.taken_by.last_name }}</template>
          <template v-else>-</template>
        </template>
        <template #given_by="{ row }">
          <template v-if="row.given_by.first_name">{{ row.given_by.first_name }} {{ row.given_by.last_name }}</template>
          <template v-else>-</template>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationProcess"
            v-if="pagination_process.pages > 1"
            v-model="pagination_process.page"
            :page-count="pagination_process.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_process.count" :count="table_process.items.length" :page="pagination_process.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getProductStorageCashRequests } from '@/http'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'

export default {
  name: 'ProductStorageCashActive',
  data() {
    return {
      is_loaded: false,
      search: '',
      table: {
        items: [],
        columns: ['id', 'date', 'amount', 'total_orders'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'amount': 'Requested amount',
            'total_orders': 'Total orders',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_process: {
        items: [],
        columns: ['id', 'date', 'amount', 'real_amount', 'efd_missing', 'difference', 'completed_orders', 'taken_by', 'given_by'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'amount': 'Given amount',
            'real_amount': 'Real amount',
            'efd_missing': 'EFD missing',
            'difference': 'Diff. Value',
            'completed_orders': 'Orders completed',
            'taken_by': 'Taken by',
            'given_by': 'Given by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_process: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      table_process_preloader: false,
    }
  },
  created() {
    this.fetchItems()
    this.fetchItemsProcess()
  },
  methods: {
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onClickPaginationProcess(page) {
      this.table_process_preloader = true
      this.pagination_process.page = page
      this.fetchItemsProcess()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    fetchItems() {
      getProductStorageCashRequests({ page: this.pagination.page, page_size: 20, search: this.search, status: 'requested' })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    fetchItemsProcess() {
      getProductStorageCashRequests({ page: this.pagination_process.page, page_size: 20, search: this.search, status: 'in_process' })
        .then(response => {
          this.table_process.items = response.data.results
          this.pagination_process.pages = response.data.pages
          this.pagination_process.count = response.data.count
          this.is_loaded = true
          this.table_process_preloader = false
        })
    },
    onOrdersSearch() {
      this.searchUsers(this)
    },
    searchUsers: debounce(vm => {
      vm.pagination.page = 1
      vm.pagination_process.page = 1
      vm.fetchItems()
      vm.fetchItemsProcess()
    }, 350),
    clientTableList(orders) {
      let result = ''
      orders.forEach(item => {
        result += `Order ID: ${item}<br>`
      })
      return result
    },
  }
}
</script>
